import axios from '@/plugins/axiosPlugin'

export default {
  state: {
    admin: [],
    adminLoading: false,
    users: [],
    usersLoading: false,
    roles: [],
    rolesLoading: [],
    generatedPassword: '',
    planUrl: '',
    tables: [],
    tablesLoading: [],
    tracker: [],
    trackerLoading: [],
    updateLoading: false,
    backendVersion: '',
    backendVersionLoading: false,
  },
  mutations: {
    setAdmin(state, admin) {
      state.admin = admin
    },
    setAdminLoading(state, adminLoading) {
      state.adminLoading = adminLoading
    },
    setUsers(state, users) {
      if(users[0]) {
        state.users = users[1]
      }
      else {
        state.users = null
      }
    },
    setUsersLoading(state, usersLoading) {
      state.usersLoading = usersLoading
    },
    setRoles(state, roles) {
      state.roles = roles      
    },
    setRolesLoading(state, usersLoading) {
      state.usersLoading = usersLoading
    },
    setTables(state, tables) {
      state.tables = tables      
    },
    setTablesLoading(state, tablesLoading) {
      state.tablesLoading = tablesLoading
    },
    setTracker(state, tracker) {
      state.tracker = tracker      
    },
    setTrackerLoading(state, trackerLoading) {
      state.trackerLoading = trackerLoading
    },
    setGeneratedPassword(state, generatedPassword) {
      state.generatedPassword = generatedPassword
    },
    setPlanUrl(state, planUrl) {
      state.planUrl = planUrl
    },
    setUpdateLoading(state, updateLoading) {
      state.updateLoading = updateLoading
    },
    setBackendVersion(state, version) {
      state.backendVersion = version
    },
    setBackendVersionLoading(state, loading) {
      state.backendVersionLoading = loading
    }
  }, 
  actions: {
    getAdmin(context) {
      context.commit('setAdminLoading', true)
      const url = 'settings/admin'
      axios
        .get(url)
        .then((response) => context.commit('setAdmin', response.data.data))
        .catch((e) => console.log("Error: " + e))
        .finally(() => context.commit('setAdminLoading', false))
    },
    registerAdmin(context, payload) {
      axios.post('register', {
        username: payload.name,
        role: payload.role
      }).then((response) => {
        context.commit('setGeneratedPassword', response.data.message)
      }).catch((e) => {
        console.error('Fehler beim Registrieren:', e)
        throw e
      })
    },
    changePassword(context, payload) {
      axios.post('changepassword', {
        username: payload.name,
        oldPassword: payload.oldPassword,
        newPassword: payload.newPassword
      }).then((response) => {
      }).catch((e) => {
        console.error('Fehler beim Passwort ändern:', e)
        throw e
      })
    },
    deleteUser(context, payload) {
      axios.post('deleteuser', {
        userToDelete: payload.userToDelete,
        userAuth: payload.userAuth,
        authPassword: payload.authPassword
      }).then((response) => {
      }).catch((e) => {
        console.error('Fehler beim Nutzer löschen:', e)
        throw e
      })
    },
    getAllUsers(context) {
      context.commit('setUsersLoading', true)
      const url = 'settings/users'
      axios
        .get(url)
        .then((response) => context.commit('setUsers', response.data.message))
        .catch((e) => console.log("Error: " + e))
        .finally(() => context.commit('setUsersLoading', false))
    },
    getAllRoles(context) {
      context.commit('setRolesLoading', true)
      const url = 'settings/userrole'
      axios
        .get(url)
        .then((response) => context.commit('setRoles', response.data.message))
        .catch((e) => console.log("Error: " + e))
        .finally(() => context.commit('setRolesLoading', false))
    },
    registerRole(context, payload) {
      const url = 'settings/userrole'
      axios.post(url , {
        name: payload.name,
        description: payload.description,
        permission: payload.permission
      }).then((response) => {
        context.commit('setGeneratedPassword', response.data.message)
      }).catch((e) => {
        console.error('Fehler beim Registrieren:', e)
        throw e
      })
    },
    getAllTables(context) {
      context.commit('setTablesLoading', true)
      const url = '/import/headers/database'
      axios
        .get(url)
        .then((response) => context.commit('setTables', response.data.message))
        .catch((e) => console.log("Error: " + e))
        .finally(() => context.commit('setTablesLoading', false))
    },
    uploadFile(context, test) {
      const url = '/lager/upload-plan'
      const axiosInstance = axios.create({
        baseURL: import.meta.env.VITE_APP_API_URL,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`
        }
      });
      axiosInstance
        .post(url, test)
        .then((response => context.commit('setPlanUrl', response.data.file_url)))
        .catch((error) => console.error(error))
    },
    update(context) {
      context.commit('setUpdateLoading', true)
      const url = 'settings/update'
      axios.post(url).then((response) => {
        context.commit('setUpdateLoading', false)
      }).catch((e) => {
        console.error('Fehler beim Registrieren:', e)
        throw e
      })
    },
    getBackendVersion(context) {
      const url = 'settings/version'
      context.commit('setBackendVersionLoading', false)
      axios
        .get(url)
        .then((response) => { context.commit('setBackendVersion', response.data.version) })
        .catch((e) => console.error("Error: " + e))
        .finally(() => context.commit('setBackendVersionLoading', false))
    },
    getAllTracker(context) {
      context.commit('setTrackerLoading', true)
      const url = '/bluetooth/tracker'
      axios
        .get(url)
        .then((response) => context.commit('setTracker', response.data.message))
        .catch((e) => console.log("Error: " + e))
        .finally(() => context.commit('setTrackerLoading', false))
    }, 
    registerTracker(context, payload) {
      const url = 'bluetooth/tracker'
      axios.post(url , {
        address: payload.address,
        serial_number: payload.serial_number,
        model: payload.model
      }).catch((e) => {
        console.error('Fehler beim Registrieren:', e)
        throw e
      })
    },
    registerLink(context, payload) {
      const url = 'bluetooth/tracker/' + payload.tracker + '/link'
      axios.post(url , {
        material: payload.material
      }).catch((e) => {
        console.error('Fehler beim Link erstellen:', e)
        throw e
      })
    },
  }
}
